import {Route, Routes} from 'react-router-dom'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'
import {PublicLayout} from '../public/PublicLayout'
import ERoutes from '../../core/enums/ERoutes'
import {AzafataSignupForm} from './components/AzafataSignupForm'
import {AlumnosSignupForm} from './components/AlumnosSignupForm'
import {TalentosSignupForm} from './components/TalentosSignupForm'

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''

const FormsPage = () => (
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path={ERoutes.FORMS_SIGNUP_STEWARDESS} element={<AzafataSignupForm />} />
        <Route path={ERoutes.FORMS_SIGNUP_FASHION} element={<AlumnosSignupForm />} />
        <Route path={ERoutes.FORMS_SIGNUP_ADVERTISING} element={<TalentosSignupForm />} />
      </Route>
    </Routes>
  </GoogleReCaptchaProvider>
)

export {FormsPage}
